import { Dialog } from "@/components/ui/dialog";
import { EditDialogContent } from "./edit/EditDialogContent";

interface ProfileEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  profile: any;
  onUpdate: () => void;
}

export const ProfileEditDialog = ({
  open,
  onOpenChange,
  profile,
  onUpdate,
}: ProfileEditDialogProps) => {
  return (
    <Dialog 
      open={open} 
      onOpenChange={onOpenChange}
      modal={true}
    >
      <EditDialogContent profile={profile} onUpdate={onUpdate} />
    </Dialog>
  );
};